import OrderedList from "@tiptap/extension-ordered-list";

export const IndentedOrderedList = OrderedList.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      indentLevel: {
        default: 0,
        parseHTML: (element: HTMLElement) => {
          const indent = element.getAttribute("data-indent");
          return indent ? parseInt(indent, 10) : 0;
        },
        renderHTML: (attributes: Record<string, number>) => {
          const indentLevel = attributes.indentLevel || 0;
          if (indentLevel <= 0) return {};

          return {
            style: `margin-left: ${indentLevel * 1.5}em`,
            "data-indent": indentLevel,
          };
        },
      },
      // textAlign: {
      //   default: null,
      //   parseHTML: (element) => element.style.textAlign || null,
      //   renderHTML: (attributes) => {
      //     if (!attributes.textAlign) {
      //       return {};
      //     }
      //     return {
      //       style: `text-align: ${attributes.textAlign}`,
      //     };
      //   },
      // },
    };
  },
});
